export default __webpack_public_path__ + "static/media/report.9fc6e62f.svg";